import { useSelector } from 'react-redux';
import { IBurgerMenuState, burgerMenuStateSelector } from './store';

export const useBurgerMenuState = (): IBurgerMenuState => {
  return useSelector(burgerMenuStateSelector);
};
